module.exports = __webpack_public_path__ + "img/nokumo-text-light-blue.999c5351.svg";